import { call, put } from 'redux-saga/effects';
import { reservations } from 'mz-sdk';
import queryStringToObject from 'mz-utils/queryStringToObject';
import { getHistory } from 'app/history';
import { initConfirmationPage } from 'app/actions/confirmation';
import { showSuccessNotification, showErrorNotification } from 'app/sagas/utils';

// Backend error codes that get a friendlier message than whatever the API
// returns (e.g. "pay_later_transaction_invalid_status" surfaces an internal
// state-machine message that's confusing to a customer).
const ERRORS_MAP = {
  pay_later_transaction_invalid_status: 'CONFIRMATION_PAGE.PAY_NOW_ERROR_MESSAGE'
};

/**
 * Buy Now, Pay Later: immediately charge a reservation's saved setup intent
 * instead of waiting for its scheduled due date.
 * @param  {Object} action  Deferred action with `payload.id` (the reservation id)
 */
export default function* chargeSetupIntent(action) {
  const { id } = action.payload;
  try {
    yield call(reservations.chargeSetupIntent, { id });
    yield call(showSuccessNotification, {
      messageId: 'CONFIRMATION_PAGE.PAY_NOW_SUCCESS_MESSAGE'
    });

    // Refresh the reservation(s) so the buttons and price breakdown's due
    // date both re-derive from the now-updated `payLater.status` (paid).
    const history = yield call(getHistory);
    const query = queryStringToObject(history.location.search);
    yield put(initConfirmationPage(query));

    yield call(action.resolvePromise);
  } catch (error) {
    const errMessageId = ERRORS_MAP[error && error.errorCode];
    yield call(showErrorNotification, {
      error: !errMessageId ? error : null,
      messageId: errMessageId
    });
    yield call(action.rejectPromise);
  }
}
